import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Glyphicon,
  Table,
} from 'react-bootstrap';

import { tryHandleGraphQLError } from '../../../utils/graphQLErrorHandlers';
import { deleteTicketAttachment } from './actions';
import { withTicketAttachments } from './graphql';
import { openInNewTab } from '../../../utils';

import TicketAttachmentsConfirmModal, {
  withConfirmAttachmentsModalState,
  confirmAttachmentsModalPropTypes,
} from './TicketAttachmentsConfirmModal';

const propTypes = exact({
  ticketId: PropTypes.number.isRequired,
  attachments: PropTypes.array.isRequired,
  deleteTicketAttachmentAction: PropTypes.func.isRequired,

  ...confirmAttachmentsModalPropTypes,
});


export class TicketAttachmentsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFileId: null,
      errorMessage: null,
    };

    this.renderTableRow = this.renderTableRow.bind(this);
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  async handleDelete() {
    const { ticketId, closeConfirmAttachmentsModal, deleteTicketAttachmentAction } = this.props;
    const { uploadedFileId } = this.state;

    try {
      closeConfirmAttachmentsModal();
      await deleteTicketAttachmentAction(ticketId, uploadedFileId);
      this.setState({ errorMessage: null });
    } catch (e) {
      const errorMessage = tryHandleGraphQLError(e);
      this.setState({ errorMessage });
    }
  }

  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th>Page Number</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
    );
  }

  renderTableRow(attachment) {
    const { openConfirmAttachmentsModal } = this.props;
    const {
      id,
      pageNumber,
      downloadUrl,
      description,
    } = attachment;

    const handleViewAttachment = (url) => {
      openInNewTab(url);
    };

    return (
      <tr key={id}>
        <td>{pageNumber}</td>
        <td>{description}</td>
        <td>
          <ButtonToolbar>
            <a
              href={downloadUrl}
              className="btn btn-xs btn-primary"
            >
              <Glyphicon glyph="download-alt" />
            </a>
            <Button
              bsStyle="info"
              bsSize="xsmall"
              onClick={() => { return handleViewAttachment(downloadUrl); }}
            >
              <Glyphicon glyph="sunglasses" />
            </Button>
            <Button
              bsStyle="danger"
              bsSize="xsmall"
              onClick={() => {
                this.setState({ uploadedFileId: id });
                return openConfirmAttachmentsModal();
              }}
            >
              <Glyphicon glyph="minus" />
            </Button>
          </ButtonToolbar>
        </td>
      </tr>
    );
  }

  render() {
    const { attachments } = this.props;

    const {
      showConfirmAttachmentsModal,
      closeConfirmAttachmentsModal,
    } = this.props;

    const { errorMessage } = this.state;
    return (
      <React.Fragment>
        <Table>
          {this.renderTableHeader()}
          <tbody>
            {attachments.map(this.renderTableRow)}
          </tbody>
        </Table>
        { errorMessage && <span>{errorMessage}</span>}
        <TicketAttachmentsConfirmModal
          show={showConfirmAttachmentsModal}
          onHide={closeConfirmAttachmentsModal}
          confirmSubmit={this.handleDelete}
        />
      </React.Fragment>
    );
  }
}


TicketAttachmentsTable.propTypes = propTypes;


const mapDispatchToProps = {
  deleteTicketAttachmentAction: deleteTicketAttachment,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withTicketAttachments,
  withConfirmAttachmentsModalState,
);

export default enhance(TicketAttachmentsTable);
